export default __webpack_public_path__ + "static/1-5_HSR_Icon-71ca1b1166ca3ca45a4645470bcc077f.png";